import * as moment from "moment";
moment.locale("pt-br");

export class ServiceRequest {
  id?: string;
  agentId?: number;
  agentName?: string;
  serviceLocalId?: string;
  serviceLocalDescription?: string;
  serviceLocalEmail?: string;
  regionalDescription?: string;
  companyDescription?: string;
  date?: string;
  hour?: string;
  situation?: string;
  observation?: string;
  attachments?: ServiceRequestAttachmentFile[];
  initialServiceTime?: string;
  endServiceTime?: string;
  serviceTime?: string;
  performedService?: string;
  accesstoken?: string;
  priority?: string;
  attendance_type?: string;
  line?: string;
  whatsapp_ddi?: string;
  whatsapp_ddd?: string;
  whatsapp_number?: string;
  email_cc?: string;

  static orderById(serviceRequests: ServiceRequest[], orderType = "asc") {
    return serviceRequests.sort((a, b) =>
      orderType === "asc" ? (a.id < b.id ? -1 : 1) : a.id > b.id ? -1 : 1
    );
  }

  static orderByCompanyDescription(
    serviceRequests: ServiceRequest[],
    orderType = "asc"
  ) {
    return serviceRequests.sort((a, b) =>
      orderType === "asc"
        ? a.companyDescription < b.companyDescription
          ? -1
          : 1
        : a.companyDescription > b.companyDescription
        ? -1
        : 1
    );
  }

  static orderByRegionalDescription(
    serviceRequests: ServiceRequest[],
    orderType = "asc"
  ) {
    return serviceRequests.sort((a, b) =>
      orderType === "asc"
        ? a.regionalDescription < b.regionalDescription
          ? -1
          : 1
        : a.regionalDescription > b.regionalDescription
        ? -1
        : 1
    );
  }

  static orderByServiceLocalDescription(
    serviceRequests: ServiceRequest[],
    orderType = "asc"
  ) {
    return serviceRequests.sort((a, b) =>
      orderType === "asc"
        ? a.serviceLocalDescription < b.serviceLocalDescription
          ? -1
          : 1
        : a.serviceLocalDescription > b.serviceLocalDescription
        ? -1
        : 1
    );
  }

  static orderByDate(serviceRequests: ServiceRequest[], orderType = "asc") {
    return serviceRequests.sort((a, b) => {
      let aDate = `${moment(a.date).format("YYYYMMDD")}${a.hour}`;
      let bDate = `${moment(b.date).format("YYYYMMDD")}${b.hour}`;

      return orderType === "asc"
        ? aDate < bDate
          ? -1
          : 1
        : aDate > bDate
        ? -1
        : 1;
    });
  }
}

export interface ServiceRequestAttachmentFile {
  name?: string;
  extension?: string;
  blob?: string | ArrayBuffer;
}

export interface ServiceLocal {
  id?: number;
  description?: string;
  active?: boolean;
  alternativeIdentifier?: number;
  corporateName?: string;
  email?: string;
  regionalId?: number;
  companyId?: number;
}
